import Vue, { ComponentOptions } from 'vue'
const template = require('./video.html') as string;

export default {
  props: ['options'],

  template: template,

  data: function () {
    var options = this['options'];

    return {
      url: options && options.url || 'https://player.vimeo.com/video/186341018?autoplay=true'
    };
  }
} as ComponentOptions<Vue>


// WEBPACK FOOTER //
// ./static-content/public/javascripts/components/video.ts